import React from 'react';
import PropTypes from 'prop-types';
import { Spacer } from '@tfecom-thermofisher/react-komodo-design';

import { Title, Icon, Message } from 'src/core/components';

import './EditPageTitle.style.scss';

const EditSequenceTitleComponent = ({ title, backButtonLabel, onBackClick }) => (
  <div data-testid="edit-page-title-wrapper">
    <Title
      size="2"
      font="thin"
      message={title}
    />

    <Spacer top="16" />

    <div className="back-to" data-testid="back-to" onClick={onBackClick}>
      <Icon name="caret-left" size={8} />
      <Message message={backButtonLabel} />
    </div>

    <Spacer bottom="32" />
  </div>
);

EditSequenceTitleComponent.propTypes = {
  title: PropTypes.object.isRequired,
  backButtonLabel: PropTypes.object.isRequired,
  onBackClick: PropTypes.func.isRequired
};

export default EditSequenceTitleComponent;
